import { Pipe, PipeTransform } from '@angular/core';
import { FacilityNote, Note } from '../models/facility-note.model';

@Pipe({
    name: 'noteWithFacContactLinks',
    pure: true,
    standalone: true
})
export class NoteWithFacContactLinksPipe implements PipeTransform {
    // People are passing Note AND FacilityNote to this pipe and they have differing properties
    // and usages. Create a new union type to allow both to be passed to the pipe.
    transform(note: Note | FacilityNote): string {
        let noteTextWithTags = note.note;
        const placeholders: Record<string, string> = {};
        let placeholderIndex = 0;

        for (const contact of note.taggedContacts) {
            const contactName = contact.contactName?.trim();
            if (contactName) {
                const regex = new RegExp(`@${contactName}`);
                const placeholder = `~~~PLACEHOLDER_${placeholderIndex}~~~`;
                noteTextWithTags = noteTextWithTags.replace(regex, placeholder);
                placeholders[placeholder] =
                    `<span data-contact-id="${contact.unitId}" data-qa-id="View-Contact-Link-${contact.unitId}" class="nova__link">${contactName}</span>`;
                placeholderIndex++;
            }
        }

        // Replace placeholders with the correct HTML
        for (const placeholder in placeholders) {
            noteTextWithTags = noteTextWithTags.replace(new RegExp(placeholder), placeholders[placeholder]);
        }

        return noteTextWithTags;
    }
}
